const indexItems = [
  { icon: 'ri-ancient-gate-line', label: '古装传奇', count: '326部' },
  { icon: 'ri-heart-line', label: '都市情感', count: '458部' },
  { icon: 'ri-search-eye-line', label: '悬疑刑侦', count: '217部' },
  { icon: 'ri-sword-line', label: '武侠江湖', count: '189部' },
  { icon: 'ri-sun-line', label: '青春偶像', count: '312部' },
  { icon: 'ri-home-smile-line', label: '家庭伦理', count: '165部' },
  { icon: 'ri-history-line', label: '历史正剧', count: '143部' },
  { icon: 'ri-aliens-line', label: '科幻奇幻', count: '98部' },
  { icon: 'ri-emotion-laugh-line', label: '喜剧搞笑', count: '274部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">剧集分类</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            全类型电视剧分类索引，快速找到你喜欢的题材
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 max-w-5xl mx-auto">
          {indexItems.map((item) => (
            <div
              key={item.label}
              className="flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 hover:bg-primary-50/20 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${item.icon} text-primary-600 group-hover:text-background-50 text-xl transition-colors duration-300`}></i>
              </div>
              <div className="text-center">
                <p className="text-sm font-semibold text-foreground-950 font-heading mb-0.5 whitespace-nowrap">{item.label}</p>
                <p className="text-xs text-foreground-400">{item.count}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}